import { render } from "./decVegas.vue?vue&type=template&id=064d65ec"
import script from "./decVegas.vue?vue&type=script&lang=js"
export * from "./decVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__